import{sizeof as r}from"./Utility.js";function t(t){var n=r(t);return function(r,o,u,i){for(var f="",e=0;e<n;e++)f+=t[e](r,o,u,i)||"";return f}}function n(r){return function(t){t.root||(t=t.return)&&r(t)}}export{t as middleware,n as rulesheet};
//# sourceMappingURL=Middleware.js.map
